import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './mobile_bar.module.scss';

type Props = {
  classNames?: string;
};

export const MobileBar: FC<Props> = ({ children, classNames }) => (
  <div className={classnames(styles.container, classNames)}>
    <div className={styles.wrapper}>{children}</div>
  </div>
);

MobileBar.defaultProps = {
  classNames: '',
};
